// extracted by mini-css-extract-plugin
export default {"line":"ShimmerSingle_line__P1cun","shimmer":"ShimmerSingle_shimmer__nuv--"};